/**
 * Mock-only: simulates `GET …/questionnaire` + per-template S3 downloads by
 * composing local schema snapshots using `estatePackageSectionPlans` catalogue
 * order. Production uses `composeEstateFlowTemplateFromDownloads` with the
 * API-returned `templates[]` order instead.
 */
import {composeEstateFlowTemplateFromDownloads} from './composeEstateFlowTemplate';
import {getTemplateSlugsForPackageType} from './estatePackageSectionPlans';
import {MOCK_TEMPLATE_SOURCES} from './mockTemplateSources';
import type {EstateFlowTemplateDocument, EstatePackageType} from './types';

const MOCK_FLOW_TEMPLATE_IDS: Record<'WILL' | 'TRUST', string> = {
  WILL: 'estate_planning_will',
  TRUST: 'estate_planning_trust',
};

export function getMockComposedFlowTemplate(packageType: EstatePackageType): EstateFlowTemplateDocument {
  if (packageType === 'ESTATE_INVENTORY') {
    return {id: 'estate_planning_inventory', sections: [], modals: {}} as EstateFlowTemplateDocument;
  }

  const downloads = getTemplateSlugsForPackageType(packageType).map((slug) => ({
    templateId: `${slug}-template`,
    body: MOCK_TEMPLATE_SOURCES[slug],
  }));

  return composeEstateFlowTemplateFromDownloads(downloads, {
    flowTemplateId: MOCK_FLOW_TEMPLATE_IDS[packageType],
    warnOnSectionMismatch: true,
  }) as EstateFlowTemplateDocument;
}
